import { omit } from 'lodash';

export const UPDATE_BLOG_DATA_REQUEST = 'appData/UPDATE_REQUEST';
export const UPDATE_BLOG_DATA_SUCCESS = 'appData/UPDATE_SUCCESS';
export const UPDATE_BLOG_DATA_FAILURE = 'appData/UPDATE_FAILURE';

export const updateAppDataRequest = () => ({ type: UPDATE_BLOG_DATA_REQUEST });
export const updateAppDataSuccess = payload => ({ type: UPDATE_BLOG_DATA_SUCCESS, payload });
export const updateAppDataFailure = () => ({ type: UPDATE_BLOG_DATA_FAILURE });

export function updateAppData(data = {}) {
  return (dispatch, getState, { request }) => {
    dispatch(updateAppDataRequest());
    const promise = request.patch('/_api/blogs/this', omit(data, ['_id', 'communityId']));

    return promise
      .then(post => dispatch(updateAppDataSuccess(post)))
      .catch(() => dispatch(updateAppDataFailure()))
      .then(() => promise);
  };
}
